import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";
import { selectUserSettingsOpen, usePanelStore } from "stores/panelStore";

import { useWorkspaceContext } from "components/workspace/hooks/useWorkspaceContext";

/**
 * Returns the current workspaceId, prioritizing workspaceIdToEdit if userSettingsOpen and set,
 * otherwise contextWorkspaceId. Returns a blank string if neither is found.
 */
export function useCurrentWorkspaceId(): string {
  const { workspaceId: currentWorkspaceId } = useWorkspaceContext();

  const workspaceIdToEdit = useSelector(
    (state: RootState) => state.userSetting.workspaceIdToEdit
  );
  const userSettingsOpen = usePanelStore(selectUserSettingsOpen);

  if (userSettingsOpen && workspaceIdToEdit) return workspaceIdToEdit;
  if (currentWorkspaceId) return currentWorkspaceId;
  return "";
}
